import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import button from "../../../assets/img/services/servicesFive/button.webp";

function ServicesFive() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className={`servicesFive-bg ${isVisible ? "visible" : ""}`}>
        <div className="servicesFive">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("services_five_title")}
          </h1>
          <div className={`line ${isVisible ? "visible" : ""}`}></div>
          <a
            className={`${isVisible ? "visible" : ""}`}
            href="/contact"
            rel="noreferrer"
            reloadDocument
          >
            <img src={button} alt="" />
            <p>{t("services_five_btn")}</p>
          </a>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default ServicesFive;
